export default "__VITE_ASSET__BFBLazHO__"